const getFieldId = (name: string) => `inquiry-${name}`;
const getLabelId = (name: string) => `inquiry-${name}-label`;

export const getInquiryLabelA11y = (name: string) => ({
  id: getLabelId(name),
});

export const getInquiryInputA11y = (name: string) => ({
  id: getFieldId(name),
  'aria-labelledby': getLabelId(name),
});

export const getInquirySelectA11y = (name: string) => ({
  inputId: getFieldId(name),
  'aria-labelledby': getLabelId(name),
});
